'use client';

import {normalizeGiftCardCode} from '@/lib/utils/giftCard.utils';
import {useSearchParams, useParams} from 'next/navigation';
import {RedeemStepsContext} from '@/context/RedeemStepsContext';
import {useState} from 'react';

export function RedeemStepsProvider({children}) {
	const searchParams = useSearchParams();
	const {code} = useParams<{code?: string}>();
	const codeToUse = code || searchParams.get('code') || '';
	const [normalizedCode, setNormalizedCode] = useState(() =>
		codeToUse ? normalizeGiftCardCode(codeToUse) || '' : ''
	);

	return (
		<RedeemStepsContext.Provider value={{code: normalizedCode, setNormalizedCode}}>
			{children}
		</RedeemStepsContext.Provider>
	);
}
